import type { ReactElement } from 'react';
import { useNavigate, useRouterState } from '@tanstack/react-router';
import { FloatingRecorderPill } from '@/components/molecules/floating-recorder-pill';
import { useRecorderContext } from '@/lib/recorder/recorder-context';

export function FloatingRecorderHost(): ReactElement | null {
  const ctx = useRecorderContext();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const isActiveStatus =
    ctx.recorder.status === 'recording' || ctx.recorder.status === 'paused';
  if (!isActiveStatus || ctx.activeArrangementId === null || ctx.returnPath === null) {
    return null;
  }
  if (pathname === ctx.returnPath) {
    return null;
  }

  const targetPath = ctx.returnPath;
  return (
    <FloatingRecorderPill
      status={ctx.recorder.status === 'paused' ? 'paused' : 'recording'}
      elapsedMs={ctx.recorder.elapsedMs}
      onReturn={() => navigate({ to: targetPath })}
    />
  );
}
